import { ReactComponent as IconEmotion } from "../../../styles/assets/svg/icon_eyes_motion.svg";

interface emotionProps {
  title: string;
  setClick: (e: any) => void;
}

export const PopupEmotion = ({ title, setClick }: emotionProps) => {
  return (
    <>
      <div
        style={{
          width: "100vw",
          maxWidth: "45rem",
          margin: "0 auto",
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end",
          zIndex: 1000,
        }}
        onClick={() => setClick(false)}
      />
      <div
        style={{
          position: "fixed",
          left: "50%",
          top: "50%",
          zIndex: 1001,
          width: "100%",
          maxWidth: "45rem",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 8,
          display: "flex",
          transform: "translate(-50%, -50%)",
        }}
      >
        <div
          style={{
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 14,
            display: "flex",
          }}
        >
          <div
            style={{
              width: 100,
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 2,
              display: "flex",
              animation: "bounceIcon 1s ease forwards",
            }}
          >
            <IconEmotion />
            <div
              style={{
                width: 80,
                height: 12,
                background: "rgba(114, 51, 0, 0.13)",
                borderRadius: 9999,
              }}
            />
          </div>
        </div>
        <div
          style={{
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            color: "var(--white, white)",
            fontSize: 24,
            fontWeight: "700",
            lineHeight: "32px",
          }}
        >
          {title}
        </div>
        <div
          style={{
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
            color: "var(--white, white)",
            fontSize: 16,
            fontWeight: "500",
            lineHeight: "24px",
          }}
        >
          10P 적립되었어요!
        </div>
      </div>
      <style>
        {`
      @keyframes bounceIcon {
        0% { transform: translateY(0); }
        25% { transform: translateY(-5px); }
        50% { transform: translateY(5px); }
        75% { transform: translateY(-3px); }
        100% { transform: translateY(0); }
      }
    `}
      </style>
    </>
  );
};
